import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';
import { IBroadcastMessageDto } from 'lingopractices-models';

export class GetMessagesSuccess {
  static get action() {
    return createAction<IBroadcastMessageDto[]>('broadcastMessages/GET_MESSAGES_SUCCESS');
  }

  static get reducer() {
    return (
      draft: IBroadcastMessagesState,
      { payload }: ReturnType<typeof GetMessagesSuccess.action>,
    ) => {
      draft.broadcastMessages = payload || [];
      draft.requests.getBroadcastMessagesPending = false;

      return draft;
    };
  }
}
